export var transportTypes;
(function (transportTypes) {
    transportTypes["STREAMABLE_HTTP"] = "streamable-http";
    transportTypes["SSE"] = "sse";
})(transportTypes || (transportTypes = {}));
export var toolConfigurationKey;
(function (toolConfigurationKey) {
    toolConfigurationKey["groundingMcpTest"] = "grounding-mcp-test";
})(toolConfigurationKey || (toolConfigurationKey = {}));
export var CommandStatus;
(function (CommandStatus) {
    CommandStatus["SUCCESS"] = "success";
    CommandStatus["FAILURE"] = "failure";
    CommandStatus["PENDING"] = "pending";
})(CommandStatus || (CommandStatus = {}));
